import { onTokenChange } from "./tokenStore";

// Dedupe de pedido EM VOO, num lugar só — e amarrado à sessão.
//
// Vários hooks pedem o mesmo dado no mesmo instante da abertura da tela
// (settings, assinatura, contagem de não lidas): compartilhar o pedido em voo
// corta as requisições duplicadas sem cache de dado — resolvido, ele some, e
// a próxima montagem busca fresco.
//
// O estoque é limpo a cada troca de token (login, renovação, logout — o
// tokenStore avisa). Sem isso, um logout/login rápido trocando de empresa
// entregava a resposta em voo da conta A para a primeira tela da conta B —
// furo de multi-tenant. Centralizar aqui é o que protege também o próximo
// módulo que precisar de dedupe: quem usa este helper já nasce limpo na
// troca de sessão, sem ter que lembrar de nada.
let emVoo = new Map();

export const pedidoEmVoo = (chave, fazer) => {
	const estoque = emVoo;
	let pedido = estoque.get(chave);

	if (!pedido) {
		pedido = fazer().finally(() => {
			// Só remove do estoque em que nasceu: se a sessão trocou no meio,
			// o mapa novo não pode perder um pedido homônimo da sessão nova.
			estoque.delete(chave);
		});
		estoque.set(chave, pedido);
	}

	return pedido;
};

onTokenChange(() => {
	// Mapa novo, não clear(): o finally de um pedido da sessão antiga segue
	// apontando para o mapa velho e não toca no da nova.
	emVoo = new Map();
});
